import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { FaAngleLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../../redux/actions/adminActions";
import ImgChangeIcon from "../../../assets/images/camera-icon.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Loader from "../../../components/Loader/Loader";
import "react-circular-progressbar/dist/styles.css";
import "../../new/new.scss";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import PDF from "../../../assets/images/pdf.svg";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Close from "../../../assets/images/close-icon.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import { useRole } from "../../../hooks/useRole";
import { roleLabel } from "../../../utils/roleLabels";
import InvestorPaymentAccounts from "./InvestorPaymentAccounts";
import { proofStatusLabels, CURRENT_PROOF_LABEL } from "./bankProofDocs";
import {
  COMPANY_STATUS_LABELS,
  COMPANY_STATUS_UNAVAILABLE,
  PERSON_STATUS_LABELS,
  PERSON_STATUS_UNAVAILABLE,
  companyStatusOf,
  decisionPreselect,
  noteOnFile,
  personStatusOf,
} from "../../../utils/personFirstAccounts";
import { askDecisionAccount, sendNamingAccountOnce } from "../../../utils/decisionAccount";

// KYC and the investor qualification are compliance decisions: a Platform
// Manager administers the account but does not decide them.
const DECIDE_FORBIDDEN =
  "Only a Dealing Representative, CCO or UDP can decide accreditation.";
const OVERSIGHT_HINT = "Decided by a compliance reviewer";
// Person-first (WP6a fix round 1): the company decision is held while the
// server's company status is not known (see the company card).
const COMPANY_DECISION_HELD =
  "The company's status could not be read, so no company decision can be recorded here. Decide the company from its Company (KYB) item in DR Approvals.";

// KYC docs are usually photos (gov-ID front/back, selfie), not PDFs. Pick the
// icon by the file extension of document_name so a .jpg stops showing the PDF
// glyph. The bytes are PRIVATE (served only via /admin/kyc-document/:id), so we
// don't fetch the blob to thumbnail it — an extension-based icon is the cheap fix.
const IMAGE_DOC_ICON =
  "data:image/svg+xml," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="56" viewBox="0 0 24 24" fill="none" stroke="#198754" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>'
  );
const isPdfDoc = (name) => /\.pdf(\?|$)/i.test(String(name || ""));

const Viewuser = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [percentage, setPercentage] = useState("");
  const dispatch = useDispatch();
  const userView = useSelector((state) => state.userView);
  const { user } = userView;
  // Person-first (WP6a): the server's statuses, from the answer's top-level
  // `accounts` block (api WP4b, companyStatus.loadAccountsBlock), never
  // recomputed from the flags. null = the answer carries none (an API before
  // WP4b, or its degraded read): both cards say the status is unavailable.
  const personStatus = personStatusOf(userView?.user);
  const companyStatus = companyStatusOf(userView?.user);
  const [get_user_id_proof_docs, set_Get_user_id_proof_docs] = useState([]);
  // Current / superseded, per document, for the company bank proofs (A3).
  const proofLabels = proofStatusLabels(get_user_id_proof_docs);
  const [corpCountry, setCorpCountry] = useState([]);
  const [countryId, setCountryId] = useState();
  const [manager, setManager] = useState([]);
  const [manId, setManId] = useState();
  const [empDesignation, seEmpDesignation] = useState([]);
  const [empid, setEmpId] = useState();
  const [roleId, setRoleId] = useState();
  const [userRoles, setUserRole] = useState([]);
  const [score, setScore] = useState();
  const [submitDate, setSubmitDate] = useState();
  const [history, setHistory] = useState([]);
  const [isDataSelected, setDataSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [roleError, setRoleError] = useState("");
  const handleClose = () => setOpen(false);

  // Canonical role & capabilities panel (Phase 5). Fed by GET
  // /admin/users/:userId/role-capabilities. AD-only actions mutate the
  // capability + qualification services.
  // Two different authorities on this page. Granting a capability or moving a
  // role is platform administration, which stays with AD. Deciding KYC or the
  // investor qualification is a regulated compliance decision, which AD no
  // longer holds: DR, CCO and UDP do.
  const { hasRole, canDecide } = useRole();
  // The company decision needs the server's company status (WP6a fix round
  // 1): without it the company may not be on file at all.
  const companyDecisionOpen = canDecide && !!companyStatus;
  const isAD = hasRole("AD");
  const [roleCaps, setRoleCaps] = useState(null);
  const [roleCapsLoading, setRoleCapsLoading] = useState(false);
  // Displayed qualification status: seeded canonically from the
  // role-capabilities payload (qualification_status), updated after an AD
  // decision; the legacy isAccreditedInvestor flag is only a fallback.
  const [qualStatus, setQualStatus] = useState(null);
  // The KYC history read is role-gated too; a 403 there is expected, not a
  // fault, and gets the same quiet line as the profile read.
  const [historyRefused, setHistoryRefused] = useState(false);

  let customer_id = userView?.user?.data?.id?.toString()?.padStart(8, "0");
  const d = new Date(user?.data?.updatedAt);
  useEffect(() => {
    dispatch(getUserDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (userView) {
      if (userView?.loading !== undefined) {
        setLoading(userView?.loading);
      }
      setPercentage(userView?.user?.data?.percentage?.percentage);
    }
  }, [userView]);

  const fetchRoleCapabilities = () => {
    const userId = id?.userId;
    if (!userId) return;
    setRoleCapsLoading(true);
    // Reset before fetching: qualification state must never carry over from
    // the previously viewed user (2026-07-24 tester finding 6).
    setQualStatus(null);
    axios
      .get(process.env.REACT_APP_API + `admin/users/${userId}/role-capabilities`, {
        headers: { "x-access-token": token },
      })
      .then((res) => {
        const data = res?.data?.data || null;
        setRoleCaps(data);
        // Canonical seed — acting-account scoped by the API. Set
        // unconditionally (null clears any prior user's status); the legacy
        // isAccreditedInvestor flag stays only as a display fallback.
        setQualStatus(data?.qualification_status || null);
      })
      .catch(() => {
        // Endpoint may be AD-gated or not deployed everywhere — fail soft, the
        // panel simply shows "unavailable" rather than blocking the page.
        setRoleCaps(null);
      })
      .finally(() => setRoleCapsLoading(false));
  };

  useEffect(() => {
    fetchRoleCapabilities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id?.userId]);

  // AD-only: grant / suspend / revoke an INVESTOR or ISSUER capability. Prompts
  // for a reason, then refreshes the panel.
  const manageCapability = async (capability, action) => {
    const userId = id?.userId;
    if (!userId) return;
    const { value: reason, isConfirmed } = await Swal.fire({
      title: `${action} ${capability}`,
      input: "text",
      inputLabel: "Reason",
      inputPlaceholder: "Why is this capability changing?",
      showCancelButton: true,
      confirmButtonText: action,
    });
    if (!isConfirmed) return;
    setLoading(true);
    try {
      await axios.post(
        process.env.REACT_APP_API + `admin/users/${userId}/capabilities`,
        { capability, action, reason: reason || undefined },
        { headers: { "x-access-token": token } }
      );
      Swal.fire({
        title: `${capability} ${action.toLowerCase()}ed`,
        timer: 2200,
        timerProgressBar: true,
        icon: "success",
        showCloseButton: true,
      });
      fetchRoleCapabilities();
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || "Capability update failed",
        icon: "error",
        showCloseButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // AD-only: approve / revoke the investor qualification (accreditation).
  // Person-first WP6b: the decision is about ONE investor account (api WP5,
  // qualification.controller decideQualification). The question "Personal" or
  // "Company" is asked first, and the body names the account (account_kind),
  // only when the server has a company qualification to decide:
  // role-capabilities qualification_by_account.ENTITY, non-null only for an
  // ENTITY investor account with a qualification row (companyQualificationOnFile).
  // Never the company status: it is DRAFT from a company name alone, with no
  // ENTITY account, and then the server needs no selector (fix round 1, F1).
  // Otherwise the body is as before; if the server still has two accounts (an
  // ENTITY account with no qualification yet) it answers 400
  // ACCOUNT_KIND_REQUIRED, and the question is asked and the decision sent
  // once more (sendNamingAccountOnce). Known residual: role-capabilities does
  // not carry the account's ACTIVE/CLOSED status, so a CLOSED company account
  // with a qualification is still asked about, and Company is then refused
  // 409 ACCOUNT_NOT_SELECTABLE as given (nothing writes CLOSED today).
  const decideQualification = async (action) => {
    const userId = id?.userId;
    if (!userId) return;
    let accountKind = null;
    if (companyQualificationOnFile(roleCaps)) {
      accountKind = await askDecisionAccount();
      if (!accountKind) return;
    }
    const { value: reason, isConfirmed } = await Swal.fire({
      title: `${action} qualification`,
      input: "text",
      inputLabel: "Reason",
      inputPlaceholder: "Reason for this decision",
      showCancelButton: true,
      confirmButtonText: action,
    });
    if (!isConfirmed) return;
    setLoading(true);
    try {
      const sent = await sendNamingAccountOnce(
        (body) =>
          axios.post(
            process.env.REACT_APP_API + `admin/users/${userId}/qualification`,
            body,
            { headers: { "x-access-token": token } }
          ),
        { action, reason: reason || undefined, ...(accountKind ? { account_kind: accountKind } : {}) },
        { beforeAsk: () => setLoading(false), afterAsk: () => setLoading(true) }
      );
      if (sent.cancelled) return;
      const res = sent.response;
      const newStatus = res?.data?.data?.status;
      Swal.fire({
        title: newStatus ? `Qualification ${newStatus.toLowerCase()}` : "Qualification updated",
        timer: 2200,
        timerProgressBar: true,
        icon: "success",
        showCloseButton: true,
      });
      // The headline is the PERSON's qualification (role-capabilities
      // qualification_status): a company decision does not move it.
      if (res?.data?.data?.account_kind !== "ENTITY") setQualStatus(newStatus || qualStatus);
      dispatch(getUserDetails(token, id));
    } catch (err) {
      Swal.fire({
        title: "Error",
        text:
          err?.response?.status === 403
            ? DECIDE_FORBIDDEN
            : err?.response?.data?.message ||
              err?.response?.data?.code ||
              "Qualification update failed",
        icon: "error",
        showCloseButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  function getformatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: customer_id + "-User-QnA",
  });

  const handleOpen = () => {
    setOpen(true);
  };

  // A refusal on the profile read is shown as a line on the page rather than a
  // modal; see getUserDetails in adminActions.
  const readRefused = !!userView?.error || historyRefused;

  //
  useEffect(() => {
    const getCountry = async () => {
      await axios
        .get(process.env.REACT_APP_API + "get-country")
        .then((res) => setCorpCountry(res.data.data))
        .catch((err) => console.log(err));
    };
    getCountry();
    viewHistory();
  }, []);

  const handleCorpCountry = (e) => {
    const getCounryId = e.target.value;
    if (!getCounryId) {
      setError("This field is required");
    } else {
      setError("");
      setCountryId(getCounryId);
      getState(getCounryId);
    }
  };

  const handleRoleChange = (event) => {
    const value = event.target.value;

    // Validate if the selected value is not empty
    if (!value) {
      setRoleError("This filed is required");
    } else {
      setRoleError("");
      setRoleId(value);
    }
  };

  const handleCorpState = (e) => {
    const getStateId = e.target.value;
    setManId(getStateId);
  };

  const getState = async (country_id) => {
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-list-of-employees",
      headers: {
        "x-access-token": token,
      },
      data: {
        limit: 500,
        page: 1,
        country_id: country_id,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        setManager(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };


  // KYC/PII documents now live in a PRIVATE blob container and are served only
  // via the authenticated GET /admin/kyc-document/:id endpoint. saveAs(public-url)
  // can't carry the x-access-token header, so fetch the bytes as a Blob (mirrors
  // AchFiles.downloadFile) and trigger a local download. Keyed on the row id.
  const downloadFileAtUrl = async (file) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}admin/kyc-document/${file?.id}`,
        {
          headers: { "x-access-token": localStorage.getItem("accessToken") },
          responseType: "blob",
        }
      );
      const blobUrl = window.URL.createObjectURL(res.data);
      const fileName = (file?.document_name || "kyc-document").split("/").pop();
      const aTag = document.createElement("a");
      aTag.href = blobUrl;
      aTag.setAttribute("download", fileName);
      document.body.appendChild(aTag);
      aTag.click();
      aTag.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("KYC document download failed:", error);
    }
  };

  useEffect(() => {
    if (userView) {
      setValue("firstname", userView?.user?.data?.firstname);
      setValue("lastname", userView?.user?.data?.lastname);
      setValue("email", userView?.user?.data?.email);
      setValue("mobile", userView?.user?.data?.phone);
      setValue("address", userView?.user?.data?.current_address);
      setValue("city", userView?.user?.data?.city);
      setValue("postal", userView?.user?.data?.postal_code);
      setValue("country", userView?.user?.data?.user_country?.country_name);
      setValue("state", userView?.user?.data?.user_state?.state_name);
      setValue("gender", userView?.user?.data?.gender);
      setValue("dob", getformatDate(userView?.user?.data?.dob));
      setValue("occupation", userView?.user?.data?.occupation);
      setValue("employer", userView?.user?.data?.employer);
      setValue("marriedStatus", userView?.user?.data?.marital_status);
      setScore(userView?.user?.data?.score);
      setSubmitDate(userView?.user?.data?.QnASubmitedAt);
      set_Get_user_id_proof_docs(userView?.user?.data?.documents);
      setValue("sin", userView?.user?.data?.sin);
      // International tax IDs: which national scheme the value belongs to
      // (CA SIN, UK NINO, ES DNI…) + optional secondary ID (ITIN/UTR/NIE…).
      setValue(
        "tax_id_meta",
        [
          userView?.user?.data?.tax_id_type,
          userView?.user?.data?.tax_country_code,
        ]
          .filter(Boolean)
          .join(" — ")
      );
      setValue(
        "sin_secondary_meta",
        userView?.user?.data?.sin_secondary
          ? `${userView.user.data.sin_secondary}${
              userView.user.data.tax_id_type_secondary
                ? ` (${userView.user.data.tax_id_type_secondary})`
                : ""
            }`
          : ""
      );
      setValue(
        "address_since_six_months",
        userView?.user?.data?.address_since_six_months
      );

      setValue("country_of_birth", userView?.user?.data?.country_of_birth);
      setValue("city_of_birth", userView?.user?.data?.city_of_birth);
      // Person-first (WP6a): each decision form starts from the SERVER's
      // status (accounts.person / accounts.company), and only from one the
      // form can record (Verified, Rejected, Expired); any other status, or
      // none, preselects nothing. The flags are not read here: the old
      // preselect turned a company message of the text 'null' into Rejected.
      // The Remark box is the investor-facing reason and is posted back, so a
      // placeholder ('null', 'undefined', 'NaN', blank) is never prefilled.
      setValue("persona_status", decisionPreselect(personStatusOf(userView?.user)));
      setValue("persona_note", noteOnFile(userView?.user?.data?.verification_error_message));
      setValue("KYC_status", decisionPreselect(companyStatusOf(userView?.user)));
      setValue("note", noteOnFile(userView?.user?.data?.comp_verification_error_message));
    }
  }, [userView]);

  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const approveUsers = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to UnBlock this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, UnBlock user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            userstatus: 1,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is Unblocked Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error?.response?.data?.message) {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not UnBlocked", "error");
      }
    });
  };

  const rejectUsers = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Block this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Block user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            userstatus: 0,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is Blocked Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error?.response?.data?.message) {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not Blocked", "error");
      }
    });
  };

  const approvePersona = async () => {
    const token = localStorage.getItem("accessToken");

    try {
      setLoading(true);
      let data1 = getValues();
      const res = await axios({
        method: "post",
        url: process.env.REACT_APP_API + "update-kyc-status",
        data: {
          userId: id.userId,
          kyc_status: data1?.persona_status,
          kyc_reason: data1?.persona_note,
          verification_type: "INDIVIDUAL",
        },
        headers: {
          "x-access-token": token,
        },
      });
      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Updated Successfuly",
          timer: 2500,
          timerProgressBar: true,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/users");
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text:
          error?.response?.status === 403
            ? DECIDE_FORBIDDEN
            : error?.response?.data?.message || "KYC status update failed",
        icon: "error",
        confirmButtonColor: "#f27474",
        confirmButtonText: "OK",
        dangerMode: true,
        showCloseButton: true,
      });
    }
  };

  const onSubmitData = async (data) => {
    let tempData = getValues();

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-kyc-status",
      headers: {
        "x-access-token": token,
      },
      data: {
        userId: id.userId,
        kyc_status: tempData?.KYC_status,
        kyc_reason: tempData?.note,
        verification_type: "CORPORATE",
      },
    };

    await axios(config)
      .then(function (response) {
        setLoading(false);
        if (response.data.status == 200) {
          Swal.fire({
            title: "Updated Successfuly",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/users");
        }
      })
      .catch(function (error) {
        setLoading(false);
        // Previously console.log only: an admin saw the form do nothing at all.
        Swal.fire({
          title: "Error",
          text:
            error?.response?.status === 403
              ? DECIDE_FORBIDDEN
              : error?.response?.data?.message || "KYC status update failed",
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
    // setDataSelected(true);
  };

  const deleteFunction = () => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id.userId,
            is_deleted: 1,
          },
        };
        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is deleted Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            navigate("/users");
          })

          .catch(function (error) {
            setLoading(false);
            if (error?.response?.data?.message) {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not deleted", "error");
      }
    });
  };

  // const getImagesArray = () => {

  //   const images = user?.data?.documents?.map((file) => {
  //     console.log("extensions", file?.document_name?.split(".").pop());
  //     const extension = file?.document_name?.split(".").pop();
  //     if (
  //       extension == "png" ||
  //       extension == "jpg" ||
  //       extension == "jpeg" ||
  //       extension == "PNG"
  //     ) {
  //       return {
  //         image: file?.document_name,
  //         files: { name: file?.document_name },
  //       };
  //     } else if (extension == "pdf") {
  //       return { image: "PDF", files: { name: file.document_name } };
  //     }
  //   });
  //   set_Get_user_id_proof_docs(images);

  //   // console.log("images", images);
  // };

  // useEffect(() => {
  //   getImagesArray();
  // }, [user]);

  const getEmployesDesignationRoles = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API +
        "get-employee-designation-systemrole-country",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id?.userId,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response?.data?.data;
        setCountryId(data?.country_id);
        setManId(data?.reporting_user_id);
        setEmpId(data?.designation_id);
        setRoleId(data?.role_id);
        if (data?.country_id) {
          getState(data?.country_id);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getEmployesDesignationRoles();
    getDesignations();
    getRoles();
  }, []);

  const getDesignations = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-rolesdesignation-listing",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        seEmpDesignation(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getRoles = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-roleslisting",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;
        setUserRole(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const viewHistory = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-user-kycdetail-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id.userId,
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        setHistory(response?.data?.data?.rows);
      })
      .catch(function (error) {
        setLoading(false);
        if (error?.response?.status === 403) {
          setHistoryRefused(true);
          return;
        }
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "add-designation-system-role",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id.userId,
        role_id: roleId,
        designation_id: empid,
        country_id: countryId,
        reporting_user_id: manId,
      },
    };
    if (!countryId && !roleId) {
      setError("This field is required");
      setRoleError("This field is required");
    } else {
      setLoading(true);
      axios(config)
        .then(function (response) {
          setLoading(false);
          if (response.data.status == 200) {
            Swal.fire({
              title: response.data.message,
              timer: 2500,
              timerProgressBar: true,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
            });
          }
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
        });
    }
  };


  return (
    <PageShell><PageHead title="User detail" /><div className="new">
      <Loader isLoading={loading} />
      <div className="newContainer">
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate("/users")} />
          </span>
          <h1 className="view-page-tittle">View User</h1>
        </div>

        {readRefused && (
          <p className="field__hint" style={{ margin: "0 0 12px" }}>
            Some of this profile is not visible to your role.
          </p>
        )}

        <RoleCapabilitiesPanel
          data={roleCaps}
          loading={roleCapsLoading}
          isAD={isAD}
          canDecide={canDecide}
          qualStatus={qualStatus}
          legacyAccreditation={user?.data?.isAccreditedInvestor}
          onCapability={manageCapability}
          onQualification={decideQualification}
        />

        <div className="bottom user-view">
          <div className="left">
            <div className="profile-pic-div userPercentage">
              <img
                src={
                  user?.data?.profilePic == null
                    ? ProfilePic
                    : user?.data?.profilePic
                }
                alt=""
                className="setting-profile userImage"
              />
              <CircularProgressbar
                value={percentage}
                strokeWidth={5}
                styles={buildStyles({
                  textColor: "red",
                  pathColor: percentage > 50 ? "#3e98c7" : "#ff9f9f",
                  // trailColor: "red"
                })}
              />
            </div>
            {/* Person-first (contract P1): entity_type is a frozen legacy
                column that decides nothing. It is shown only as the legacy
                sign-up type; the accounts are the KYC cards below. */}
            {user?.data?.entity_type ? (
              <p className="entity-type" data-testid="legacy-entity-type">
                Legacy sign-up type: {user.data.entity_type}
              </p>
            ) : null}

            <p className="last-updatedAt">
              {d?.toDateString() + ", " + d?.getHours() + ":" + d?.getMinutes()}
            </p>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  disabled={true}
                  {...register("firstname")}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  disabled={true}
                  {...register("lastname")}
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  {...register("email")}
                  placeholder="Enter Email"
                />
              </div>

              <div className="formInput">
                <label>Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  disabled={true}
                  {...register("mobile")}
                  placeholder="Enter Mobile"
                />
              </div>
              <div className="formInput">
                <label>Address</label>
                <input
                  type="text"
                  name="address"
                  disabled={true}
                  {...register("address")}
                  placeholder="Enter Address"
                />
              </div>
              <div className="formInput">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  disabled={true}
                  {...register("city")}
                  placeholder="Enter City"
                />
              </div>

              <div className="formInput">
                <label>Country</label>
                <input
                  type="text"
                  name="country"
                  disabled={true}
                  {...register("country")}
                  placeholder="Enter Country"
                />
              </div>
              <div className="formInput">
                <label>State/Province</label>
                <input
                  type="text"
                  name="state"
                  disabled={true}
                  {...register("state")}
                  placeholder="Enter State"
                />
              </div>
              <div className="formInput">
                <label>Postal Code</label>
                <input
                  type="text"
                  name="postal"
                  disabled={true}
                  {...register("postal")}
                  placeholder="Enter Postal Code"
                />
              </div>
              {/* <div className="formInput">
                <label>Gender</label>
                <input
                  type="text"
                  name="gender"
                  disabled={true}
                  {...register("gender")}
                  placeholder="Enter Gender"
                />
              </div>
              <div className="formInput">
                <label>Marital Status</label>
                <input
                  type="text"
                  name="marriedStatus"
                  disabled={true}
                  {...register("marriedStatus")}
                  placeholder="Enter Marital Status"
                />
              </div> */}
              <div className="formInput">
                <label>DOB</label>
                <input
                  type="date"
                  name="dob"
                  // disabled={true}
                  {...register("dob")}
                  placeholder="MM/DD/YYYY"
                />
              </div>
              <div className="formInput">
                <label>VAT # / TIN / SIN / CF</label>
                <input
                  type="text"
                  name="sin"
                  disabled={true}
                  {...register("sin")}
                  placeholder="Tax identification number"
                />
              </div>
              <div className="formInput">
                <label>Tax ID Type — Country</label>
                <input
                  type="text"
                  name="tax_id_meta"
                  disabled={true}
                  {...register("tax_id_meta")}
                  placeholder="e.g. SIN — CA"
                />
              </div>
              <div className="formInput">
                <label>Secondary Tax ID</label>
                <input
                  type="text"
                  name="sin_secondary_meta"
                  disabled={true}
                  {...register("sin_secondary_meta")}
                  placeholder="e.g. NIE / ITIN / UTR"
                />
              </div>
              <div className="formInput">
                <label>Address Since Six Months</label>
                <input
                  type="text"
                  name="address_since_six_months"
                  disabled={true}
                  {...register("address_since_six_months")}
                />
              </div>
              <div className="formInput">
                <label>Country of Birth</label>
                <input
                  type="text"
                  name="country_of_birth"
                  disabled={true}
                  {...register("country_of_birth")}
                />
              </div>
              <div className="formInput">
                <label>City of Birth</label>
                <input
                  type="text"
                  name="city_of_birth"
                  disabled={true}
                  {...register("city_of_birth")}
                />
              </div>

              <div className="formInput"></div>
              <div className="roleDesiBlock">
                <hr></hr>
                <h3>User Verification Documents</h3>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Employment Information</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">
                        Type of Investor <i>(Individual)</i>:
                      </span>
                      <span class="itemValue">
                        {user?.data?.type_of_investor}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Status of employment:</span>
                      <span class="itemValue">
                        {user?.data?.employment_status}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Years Employed:</span>
                      <span class="itemValue">
                        {user?.data?.employment_year == null
                          ? "N/A"
                          : user?.data?.employment_year}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Occupation:</span>
                      <span class="itemValue">{user?.data?.occupation}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Employer/Company:</span>
                      <span class="itemValue">{user?.data?.employer}</span>
                    </div>

                    <div class="detailItem">
                      <span class="itemKey">Approximate Annual Income:</span>
                      <span class="itemValue">{user?.data?.annual_income}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Political Person Name:</span>
                      <span class="itemValue">
                        {user?.data?.politician_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Source of funds:</span>
                      {Array.isArray(user?.data?.fund_source)
                        ? user.data?.fund_source?.map((fund) => (
                            <li class="itemValue">{fund}</li>
                          ))
                        : ""}
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Company Information</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">
                        Type of Investor <i>(Corporate)</i>:
                      </span>
                      <span class="itemValue">
                        {user?.data?.comp_type_of_investor}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Company Name:</span>
                      <span class="itemValue">{user?.data?.comp__name}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Type of Sector:</span>
                      <span class="itemValue">
                        {user?.data?.comp_type_of_sector}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">VAT Number:</span>
                      <span class="itemValue">{user?.data?.comp_vat}</span>
                    </div>
                  </div>
                </div>
                <hr></hr>
                {/* Corporate Business PAD contract (2026-10-25): one card per
                    investor account from the instrument versions, masked,
                    with the proof document and the compliance Verify /
                    Reject. Replaces the two blocks rendered for every user
                    from user_banking_details[0] with full numbers.
                    Amendment A1: this is the AD surface, so the cards are
                    read-only unless the session holds a compliance seat
                    (canDecide: DR, CCO or UDP; an AD alone reads). The
                    decisions also wait for the profile shown here to be the
                    route's user (a late answer for another user, or none). */}
                <InvestorPaymentAccounts
                  userId={id?.userId}
                  canDecide={canDecide}
                  requireProfile
                  profileUserId={user?.data?.id}
                />
                <hr></hr>
                <div className="user-que-main-div">
                  <h4 className="user-que-subtitle">Fiscal Residence</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">Country:</span>
                      <span class="itemValue">
                        {user?.data?.comp_country?.country_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Province:</span>
                      <span class="itemValue">
                        {user?.data?.comp_state?.state_name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">City:</span>
                      <span class="itemValue">
                        {user?.data?.comp_city?.name}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Company Address:</span>
                      <span class="itemValue">{user?.data?.comp_address}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Postal Code:</span>
                      <span class="itemValue">
                        {user?.data?.comp_postal_code}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Phone Number:</span>
                      <span class="itemValue">
                        {user?.data?.comp_phone_num}
                      </span>
                    </div>
                  </div>
                </div>
                <hr></hr>
                {/* Amendment A3: a company bank proof is retired (status 0),
                    never deleted, so the list can hold several. The status 1
                    row is the current proof; every other one is labelled a
                    superseded proof (bankProofDocs). */}
                <div className="images verfication-document">
                  {get_user_id_proof_docs?.length > 0 ? (
                    get_user_id_proof_docs?.map((image, index) => (
                      <>
                        <div className="img-preview-div" key={index}>
                          <img
                            src={isPdfDoc(image?.document_name) ? PDF : IMAGE_DOC_ICON}
                            alt=""
                            style={{
                              height: "70px",
                              widht: "50px",
                            }}
                            className="img-preview-img"
                          />
                          <div>
                            {decodeURI(image?.document_name).split("-").pop()}
                          </div>
                          <p className="doc-title">
                            <span>DOC Type:</span>
                            {image?.doc_title}
                          </p>
                          <p className="doc-title">
                            <span>DOC ID:</span>
                            {image?.document_id}
                          </p>
                          <p className="doc-title">
                            <span>Expiration:</span>
                            {image?.document_expiration}
                          </p>
                          {proofLabels[index] && (
                            <p
                              className="doc-title"
                              data-proof-status={proofLabels[index] === CURRENT_PROOF_LABEL ? "current" : "superseded"}
                            >
                              <span>Proof:</span>
                              {proofLabels[index]}
                            </p>
                          )}

                          <button
                            type="button"
                            className="approveButton downloadbtn"
                            onClick={() => {
                              downloadFileAtUrl(image);
                            }}
                          >
                            Download
                          </button>
                        </div>
                      </>
                    ))
                  ) : (
                    <h6>No Data Found</h6>
                  )}
                </div>
              </div>
              <div className="roleDesiBlock">
                <hr></hr>
                <div className="questionans-div">
                  <h3>User Questions and Answer</h3>
                  {user?.data?.QnA.length > 0 ? (
                    <button
                      type="button"
                      className="approveButton downloadbtn"
                      onClick={handlePrint}
                    >
                      Download
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="user-que-main-div" ref={componentRef}>
                  <h4 className="user-que-subtitle">User Details</h4>
                  <div className="user-que-info">
                    <div class="detailItem">
                      <span class="itemKey">Customer ID:</span>
                      <span class="itemValue">{customer_id}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Name:</span>
                      <span class="itemValue">
                        {user?.data?.firstname + " " + user?.data?.lastname}
                      </span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Email:</span>
                      <span class="itemValue">{user?.data?.email}</span>
                    </div>
                    <div class="detailItem">
                      <span class="itemKey">Accreditation:</span>
                      <span class="itemValue">
                        {user?.data?.isAccreditedInvestor == 3
                          ? "Accredited User"
                          : "Regular User"}
                      </span>
                    </div>
                    {score && (
                      <div class="detailItem">
                        <span class="itemKey">Score:</span>
                        <span class="itemValue">{score}</span>
                      </div>
                    )}
                    {submitDate && (
                      <div class="detailItem">
                        <span class="itemKey">Date Submitted:</span>
                        <span class="itemValue">
                          {submitDate?.substring(0, 10)}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Person-first (WP6a, UI-07): every user is a person first,
                      so the person's KYC card is ALWAYS shown, a legacy
                      entity_type CORPORATE user included. Its status is the
                      server's accounts.person.status. */}
                    <div className="questionblock" data-testid="person-kyc-card">
                      <hr></hr>

                      <div className="title-topSection">
                        <h4 className="user-que-subtitle">
                          Individual Profile (Persona) Verification
                        </h4>
                        {/* The log holds the person's and the company's
                            decisions; it sits on the card that is always
                            shown. */}
                        <button
                          type="button"
                          onClick={handleOpen}
                          className="editButton"
                        >
                          Log History
                        </button>
                      </div>

                      <div className="kycDetails-section">
                        <div className="formInput">
                          <strong className="itemKey">Status:</strong>
                          <p className="readonly-text" data-testid="person-kyc-status">
                            {personStatus
                              ? PERSON_STATUS_LABELS[personStatus] || personStatus
                              : PERSON_STATUS_UNAVAILABLE}
                          </p>
                        </div>
                        <div className="formInput">
                          <strong>Remark/Note/Reason:</strong>
                          <p className="readonly-text">
                            {noteOnFile(userView?.user?.data?.verification_error_message) ||
                              "-"}
                          </p>
                        </div>
                        <div className="formInput">
                          <label>Status</label>
                          <select
                            name="persona_status"
                            {...register("persona_status", {
                              required: "Persona status is required",
                            })}
                          >
                            <option value="" disabled selected hidden>
                              Select
                            </option>
                            <option value="VERIFIED">Verified</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="EXPIRED">Expired</option>
                          </select>
                          {errors.persona_status && (
                            <div className="invalid-feedback">
                              {errors.persona_status.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput">
                          <label>Remark/Note/Reason</label>
                          <textarea
                            className="txtInput"
                            rows={3}
                            {...register("persona_note")}
                            name="persona_note"
                          />
                        </div>

                        <div className="kycUpdate-div">
                          <button
                            type="button"
                            className="approveButton"
                            disabled={!canDecide}
                            title={canDecide ? undefined : OVERSIGHT_HINT}
                            onClick={canDecide ? approvePersona : undefined}
                          >
                            Update
                          </button>
                          {!canDecide && (
                            <span className="field__hint">{OVERSIGHT_HINT}</span>
                          )}
                        </div>
                      </div>
                    </div>

                  {/* Person-first (WP6a): the company card follows the
                      server's accounts.company.status. NONE (no company on
                      file) hides it; any other status shows it with that
                      status; no status in the answer (an API before WP4b,
                      its degraded read, or a refused profile read) shows it
                      with "Company status unavailable" and HOLDS its
                      decision. The server does not check that a company is
                      on file: a CORPORATE VERIFIED for a verified person with
                      no company is accepted and locks the company (api
                      kycStatus.applyKycStatus checks only the person;
                      companyLock refuses the first company values). The
                      company is then decided from its KYB item in DR
                      Approvals. The bank cards (InvestorPaymentAccounts,
                      above) are NOT in this card and never follow its
                      status. */}
                  {companyStatus !== "NONE" && (
                    <div className="questionblock" data-testid="company-kyb-card">
                      <hr />

                      <div className="title-topSection">
                        <h4 className="user-que-subtitle">
                          Corporate Profile KYC Verification
                        </h4>
                      </div>

                      <div className="kycDetails-section">
                        <div className="formInput">
                          <strong className="itemKey">Status:</strong>
                          <p className="readonly-text" data-testid="company-kyb-status">
                            {companyStatus
                              ? COMPANY_STATUS_LABELS[companyStatus] || companyStatus
                              : COMPANY_STATUS_UNAVAILABLE}
                          </p>
                        </div>
                        <div className="formInput">
                          <label>Status</label>
                          <select
                            name="KYC_status"
                            {...register("KYC_status", {
                              required: "KYC status is required",
                            })}
                          >
                            <option value="" disabled selected hidden>
                              Select
                            </option>
                            <option value="VERIFIED">Verified</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="EXPIRED">Expired</option>
                          </select>
                          {errors.KYC_status && (
                            <div className="invalid-feedback">
                              {errors.KYC_status.message}
                            </div>
                          )}
                        </div>

                        <div className="formInput">
                          <label>Remark/Note/Reason</label>
                          <textarea
                            className="txtInput"
                            rows={3}
                            {...register("note")}
                            name="note"
                          />
                        </div>

                        <div className="kycUpdate-div">
                          <button
                            type="button"
                            className="approveButton"
                            disabled={!companyDecisionOpen}
                            title={
                              !canDecide
                                ? OVERSIGHT_HINT
                                : companyDecisionOpen
                                ? undefined
                                : COMPANY_DECISION_HELD
                            }
                            onClick={companyDecisionOpen ? onSubmitData : undefined}
                          >
                            Update
                          </button>
                          {!canDecide ? (
                            <span className="field__hint">{OVERSIGHT_HINT}</span>
                          ) : (
                            !companyStatus && (
                              <span className="field__hint">{COMPANY_DECISION_HELD}</span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="questionblock">
                    <hr></hr>

                    <div className="title-topSection">
                      <h4 className="user-que-subtitle">
                        Questions and Answer
                      </h4>
                      {user && user?.data?.score && (
                        <div>
                          <p className="user-statusTxt">
                            <span>Status: </span>
                            {user?.data?.score < 54
                              ? "Inappropriate"
                              : "Appropriate"}
                          </p>
                          <p className="user-statusTxt">
                            <span>Score: </span>
                            {user?.data?.score}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="ques-ans-main">
                      <div className="ques-ans-new">
                        <h2>Bear Losess Test</h2>
                        {""}
                        {user && user.data.QnA.basic ? (
                          user?.data?.QnA?.basic?.map((ques, index) => (
                            <>
                              <div
                                className="detailItem companyInfo"
                                key={index}
                              >
                                <p className="questiontext">{ques?.question}</p>
                                <p className="itemValue">
                                  <b>Ans:</b>&nbsp;
                                  {ques?.answer}
                                </p>
                              </div>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                      <div className="ques-ans-old">
                        {" "}
                        <h2>Appropriateness Test</h2>
                        {""}
                        {user && user?.data?.QnA?.evaluation ? (
                          user?.data?.QnA?.evaluation?.map((que, index) => (
                            <>
                              <div
                                className="detailItem companyInfo"
                                key={index}
                              >
                                <p className="questiontext">
                                  {/* <span>Question {index + 1}.</span>&nbsp; */}
                                  {/* {que?.evaluation_investor_profile_question
                                ? que?.evaluation_investor_profile_question
                                    ?.q_en
                                : que?.question} */}
                                  {
                                    que?.evaluation_investor_profile_question
                                      ?.q_en
                                  }
                                </p>
                                <p className="itemValue">
                                  <b>Ans:</b>&nbsp;
                                  {/* {que?.answer} */}
                                  {/* {
                                que.evaluation_investor_profile_option
                                  ?.option_en
                              } */}
                                  {
                                    que?.evaluation_investor_profile_option
                                      ?.option_en
                                  }
                                </p>
                              </div>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>

                    {/* new q/a */}
                  </div>
                </div>
              </div>
              <div className="roleDesiBlock">
                <hr></hr>
                <h3>Roots Roles and Designations</h3>
                <p style={{ color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "8px 12px", fontSize: 13, margin: "0 0 12px" }}>
                  Legacy designation system — no longer grants platform authority.
                  Platform roles and capabilities are managed in the Role &amp;
                  capabilities panel above.
                </p>
                <div className="designationRole-wrapper">
                  <div className="formInput">
                    <label>Reporting Country</label>
                    {/* <Select
                      options={countries}
                      onChange={handleChangeCountry}
                      value={getCountry}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationCountry"
                      onChange={(e) => handleCorpCountry(e)}
                      value={countryId}
                    >
                      <option value="" disabled selected>
                        Select Country
                      </option>
                      {corpCountry?.map((getCon, index) => (
                        <option key={index} value={getCon?.id}>
                          {getCon?.country_name}
                        </option>
                      ))}
                    </select>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </div>
                  <div className="formInput">
                    <label>Reporting Manager</label>
                    {/* <Select
                      options={employees}
                      onChange={handleChangeManager}
                      value={getEmployee}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={(e) => handleCorpState(e)}
                      value={manId}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {manager.map((getName, index) => (
                        <option key={index} value={getName?.users?.id}>
                          {getName?.users?.firstname +
                            " " +
                            getName?.users?.lastname +
                            "--" +
                            getName?.designation?.designation}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="formInput">
                    <label>Root Designation</label>

                    {/* <Select
                      options={designations}
                      onChange={handleChangeDesignations}
                      value={getDesignation}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={(e) => setEmpId(e.target.value)}
                      value={empid}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {empDesignation.map((getName, index) => (
                        <option key={index} value={getName.id}>
                          {getName?.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="formInput">
                    <label>Roles</label>
                    {/* <Select
                      options={roles}
                      onChange={handleChangeRoles}
                      value={getRole}
                    /> */}
                    <select
                      className="txtInput"
                      name="corporationState"
                      onChange={handleRoleChange}
                      value={roleId}
                    >
                      <option value="" disabled selected>
                        Select Value
                      </option>
                      {userRoles.map((getRole, index) => (
                        <option key={index} value={getRole.id}>
                          {getRole?.role}
                        </option>
                      ))}
                    </select>
                    {roleError && <p style={{ color: "red" }}>{roleError}</p>}
                  </div>

                  <button
                    type="button"
                    className="approveButton"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>


              {/* <div className="formInput"></div> */}

              <div className="submitButton">
                {userView?.user?.data?.userStatus == 1 ? (
                  <button
                    type="button"
                    className="approveButton"
                    onClick={rejectUsers}
                  >
                    Block
                  </button>
                ) : (
                  <button
                    type="button"
                    className="declineButton"
                    onClick={approveUsers}
                  >
                    Unblock
                  </button>
                )}
                <button
                  type="button"
                  className="declineButton"
                  onClick={deleteFunction}
                >
                  Delete
                </button>
              </div>
            </form>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-popup">
                <div className="modal-top kycModal-top">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    KYC Activity
                  </Typography>
                  <Button className="closeBtn" onClick={() => setOpen(false)}>
                    <img src={Close} alt="close-icon" />
                  </Button>
                </div>
                <div className="kyclog-listing">
                  {history?.map((status, index) => {
                    const d = new Date(status?.timestamp);
                    return (
                      <Typography
                        id="modal-modal-description"
                        className="typography_kyc"
                        sx={{ mt: 1 }}
                      >
                        <div className="new">
                          <div className="newContainer">
                            <div
                              className="bottom"
                              style={{
                                boxShadow: "none",
                                margin: "2px",
                                padding: "0",
                              }}
                            >
                              <div className="right kycDetails-wrapper">
                                <form className="kyc-form">
                                  <div className="kycMain-wrapper">
                                    <div className="history-infoWrap">
                                      <Typography>
                                        {d?.getHours() +
                                          ":" +
                                          d?.getMinutes() +
                                          ", " +
                                          d?.toDateString()}{" "}
                                        &nbsp;
                                      </Typography>
                                      <Typography>
                                        {status?.KYC_status} &nbsp;
                                      </Typography>
                                    </div>

                                    <div className="remark-wrapper">
                                      <p> {status?.KYC_reason} &nbsp; </p>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Typography>
                    );
                  })}
                </div>
              </Box>
            </Modal>
          </div>
        </div>
      </div>
    </div></PageShell>
  );
};

// ── Canonical role & capabilities panel (Phase 5) ─────────────────────────────
// Read-only summary of the user's active canonical role, capability grants,
// assignment history and sponsorship, plus AD-only action buttons. Kept as a
// local presentational component so Viewuser's giant render stays readable.

const CAP_TONE = {
  ACTIVE: "#065f46",
  GRANTED: "#065f46",
  SUSPENDED: "#92400e",
  REVOKED: "#991b1b",
  PENDING: "#92400e", // SELF_DECLARED awaiting AD review
};

// Does the server have a company qualification to decide? role-capabilities
// qualification_by_account.ENTITY (api WP5, admin_roles.controller
// getUserRoleCapabilities) is the status of the user's ENTITY investor
// account's qualification, null when there is no such account or row. The
// Approve/Revoke buttons render only with this answer loaded
// (RoleCapabilitiesPanel shows none without data).
function companyQualificationOnFile(roleCaps) {
  const status = roleCaps?.qualification_by_account?.ENTITY;
  return typeof status === "string" && status.trim() !== "";
}

// Legacy isAccreditedInvestor → qualification status label (fallback when the
// panel has no explicit qualification_status).
function legacyQualLabel(flag) {
  if (flag === 3 || flag === "3") return "APPROVED";
  if (flag === 4 || flag === "4") return "REVOKED";
  // SELF_DECLARED has no legacy flag value; it arrives canonically via the
  // role-capabilities payload's qualification_status.
  return "—";
}

const panelBox = {
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  padding: 16,
  margin: "0 0 20px",
  background: "#fff",
};
const chip = (status) => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: 12,
  fontSize: 12,
  fontWeight: 600,
  color: CAP_TONE[status] || "#374151",
  background: "#f3f4f6",
});

const RoleCapabilitiesPanel = ({
  data,
  loading,
  isAD,
  canDecide,
  qualStatus,
  legacyAccreditation,
  onCapability,
  onQualification,
}) => {
  if (loading) {
    return (
      <div style={panelBox}>
        <p style={{ margin: 0, color: "#666" }}>Loading role & capabilities…</p>
      </div>
    );
  }
  if (!data) {
    return (
      <div style={panelBox}>
        <h3 style={{ margin: "0 0 4px", fontSize: 16 }}>Role &amp; capabilities</h3>
        <p style={{ margin: 0, color: "#666", fontSize: 13 }}>
          Role &amp; capability details are not available for this user.
        </p>
      </div>
    );
  }

  const assignments = Array.isArray(data.assignments) ? data.assignments : [];
  const capabilities = Array.isArray(data.capabilities) ? data.capabilities : [];
  const byCapability = {};
  capabilities.forEach((c) => {
    // First (most recent — API orders id DESC) wins per capability.
    if (!byCapability[c.capability]) byCapability[c.capability] = c;
  });
  const sponsorship = data.sponsorship || null;
  const displayQual = qualStatus || legacyQualLabel(legacyAccreditation);

  const CAPABILITY_ROWS = ["INVESTOR", "ISSUER"];

  return (
    <div style={panelBox}>
      <h3 style={{ margin: "0 0 12px", fontSize: 16 }}>Role &amp; capabilities</h3>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 24 }}>
        <div>
          <div style={{ fontSize: 12, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>
            Active role
          </div>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{roleLabel(data.active_role)}</div>
        </div>
        {sponsorship && (
          <div>
            <div style={{ fontSize: 12, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Sponsoring BDC
            </div>
            <div style={{ fontSize: 15 }}>
              {sponsorship.sponsoring_bdc_name ||
                (sponsorship.sponsoring_bdc_user_id ? `#${sponsorship.sponsoring_bdc_user_id}` : "—")}
              <span style={chip(sponsorship.status)} className="ml">
                {" "}
                {sponsorship.status}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Capabilities — shown independently of the platform role. */}
      <div style={{ marginTop: 16 }}>
        <div style={{ fontSize: 12, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
          Capabilities
        </div>
        <table className="tbl" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: "4px 8px" }}>Capability</th>
              <th style={{ textAlign: "left", padding: "4px 8px" }}>Status</th>
              <th style={{ textAlign: "left", padding: "4px 8px" }}>Granted via</th>
              {isAD && <th style={{ textAlign: "right", padding: "4px 8px" }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {CAPABILITY_ROWS.map((cap) => {
              const c = byCapability[cap];
              const status = c?.status || "NONE";
              return (
                <tr key={cap} style={{ borderTop: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "6px 8px", fontWeight: 600 }}>{cap}</td>
                  <td style={{ padding: "6px 8px" }}>
                    <span style={chip(status)}>{status}</span>
                  </td>
                  <td style={{ padding: "6px 8px", color: "#6b7280", fontSize: 13 }}>
                    {c?.granted_source || "—"}
                  </td>
                  {isAD && (
                    <td style={{ padding: "6px 8px", textAlign: "right" }}>
                      <button type="button" className="approveButton" style={{ marginLeft: 6 }} onClick={() => onCapability(cap, "GRANT")}>
                        Grant
                      </button>
                      <button type="button" className="editButton" style={{ marginLeft: 6 }} onClick={() => onCapability(cap, "SUSPEND")}>
                        Suspend
                      </button>
                      <button type="button" className="declineButton" style={{ marginLeft: 6 }} onClick={() => onCapability(cap, "REVOKE")}>
                        Revoke
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Investor qualification (accreditation). */}
      <div style={{ marginTop: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <div>
          <span style={{ fontSize: 12, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em" }}>
            Qualification
          </span>{" "}
          <span
            style={chip(
              displayQual === "APPROVED"
                ? "ACTIVE"
                : displayQual === "REVOKED"
                  ? "REVOKED"
                  : displayQual === "SELF_DECLARED"
                    ? "PENDING"
                    : ""
            )}
          >
            {displayQual}
          </span>
        </div>
        {canDecide ? (
          <div>
            <button type="button" className="approveButton" onClick={() => onQualification("APPROVE")}>
              Approve
            </button>
            <button type="button" className="declineButton" style={{ marginLeft: 6 }} onClick={() => onQualification("REVOKE")}>
              Revoke
            </button>
          </div>
        ) : (
          <div>
            <button type="button" className="approveButton" disabled title={OVERSIGHT_HINT}>
              Approve
            </button>
            <button type="button" className="declineButton" style={{ marginLeft: 6 }} disabled title={OVERSIGHT_HINT}>
              Revoke
            </button>
            <span className="field__hint" style={{ marginLeft: 8 }}>{OVERSIGHT_HINT}</span>
          </div>
        )}
      </div>

      {/* Assignment history. */}
      {assignments.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontSize: 12, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
            Assignment history
          </div>
          <table className="tbl" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "4px 8px" }}>Role</th>
                <th style={{ textAlign: "left", padding: "4px 8px" }}>Status</th>
                <th style={{ textAlign: "left", padding: "4px 8px" }}>Assigned</th>
                <th style={{ textAlign: "left", padding: "4px 8px" }}>Revoked</th>
                <th style={{ textAlign: "left", padding: "4px 8px" }}>Reason</th>
              </tr>
            </thead>
            <tbody>
              {assignments.map((a) => (
                <tr key={a.id} style={{ borderTop: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "6px 8px" }}>{roleLabel(a.role_code)}</td>
                  <td style={{ padding: "6px 8px" }}>
                    <span style={chip(a.status)}>{a.status}</span>
                  </td>
                  <td style={{ padding: "6px 8px", color: "#6b7280", fontSize: 13 }}>
                    {a.assigned_at ? new Date(a.assigned_at).toLocaleString() : "—"}
                  </td>
                  <td style={{ padding: "6px 8px", color: "#6b7280", fontSize: 13 }}>
                    {a.revoked_at ? new Date(a.revoked_at).toLocaleString() : "—"}
                  </td>
                  <td style={{ padding: "6px 8px", color: "#6b7280", fontSize: 13 }}>{a.reason || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

/**
 * One page per user. The profile is read on mount, so a hash-route change
 * from user A to user B remounts the page and reads B's profile: nothing kept
 * in this page's state for A survives on B's page. The profile itself lives
 * in the store until B's read lands, so the bank decisions also check that
 * the profile shown is B's (InvestorPaymentAccounts, profileUserId).
 */
const ViewuserRoute = () => {
  const { userId } = useParams();
  return <Viewuser key={userId} />;
};

export default ViewuserRoute;
